var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoteHealth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.245,
    height: 48.447,
    viewBox: "0 0 64.245 48.447",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12934",
    d: "M8.573 28.461A1.368 1.368 0 0 0 9.9 26.775a14.475 14.475 0 0 1-.4-3.385c0-6.739 5.221-12.223 11.639-12.223 6.641 0 11.508 4.627 11.573 11a1.367 1.367 0 0 0 2.734 0c.066-6.374 4.933-11 11.574-11 6.418 0 11.639 5.483 11.639 12.223a14.429 14.429 0 0 1-.39 3.328 1.367 1.367 0 0 0 2.66.63 17.219 17.219 0 0 0 .463-3.958c0-8.247-6.448-14.956-14.373-14.956-5.923 0-10.706 3-12.94 7.658-2.234-4.655-7.016-7.658-12.94-7.658-7.925 0-14.372 6.709-14.372 14.956a17.236 17.236 0 0 0 .479 4.025 1.366 1.366 0 0 0 1.327 1.046z",
    transform: "translate(-1.337 -8.433)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12935",
    d: "m50.879 32.654-17.7 17.619-17.584-17.5a1.367 1.367 0 1 0-1.929 1.938l18.545 18.46a1.368 1.368 0 0 0 1.929 0l18.667-18.579a1.367 1.367 0 1 0-1.929-1.938z",
    transform: "translate(-.435 -5.121)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12936",
    d: "M65.557 29.163a1.818 1.818 0 0 0-2.325 0H43.316a1.843 1.843 0 0 0-3.016 1.428c0 .038.009.072.011.109l-5.338 7.09-8.332-16.61A1.85 1.85 0 1 0 23 20.706c0 .047.011.092.014.138l-6.255 8.314H5.016a1.849 1.849 0 1 0 .157 2.734h12.272a1.366 1.366 0 0 0 1.093-.545l6.086-8.09 8.357 16.66a1.85 1.85 0 1 0 3.613.559 1.9 1.9 0 0 0-.026-.259l5.873-7.8a1.842 1.842 0 0 0 1.031-.523h19.6a1.85 1.85 0 0 0 3.17-1.3c.002-.582-.001-1.094-.685-1.431z",
    transform: "translate(-2 -6.984)",
    style: {
      fill: "#d24350"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoteHealth);
export default __webpack_public_path__ + "static/media/remote-health.e8e278342cc120b38edc392df2366fe0.svg";
export { ForwardRef as ReactComponent };